import { IconWrapper } from '../runtime';
export default IconWrapper('bulb', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M6.22787 14.9997H9.77142M8.37587 4.16479L7.60772 5.31702C7.49385 5.48781 7.5813 5.71994 7.77954 5.77317L8.21975 5.89135C8.418 5.94458 8.50544 6.17671 8.39158 6.3475L7.62342 7.49973M6.22787 12.2497H9.77142C9.90628 12.2497 10.0246 12.1597 10.0605 12.0297L10.4396 10.6605C10.7177 9.65575 11.3772 8.80593 11.914 7.91215C12.3256 7.22667 12.5624 6.42414 12.5624 5.56633C12.5624 3.0463 10.5195 1.00342 7.99944 1.00342C5.47941 1.00342 3.43652 3.0463 3.43652 5.56633C3.43652 6.42425 3.6733 7.22688 4.08506 7.91242C4.62192 8.80623 5.28153 9.65607 5.55975 10.6609L5.93875 12.0297C5.97474 12.1597 6.09302 12.2497 6.22787 12.2497Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});